import { render, staticRenderFns } from "./HubDropdownMenu.vue?vue&type=template&id=1423c642&"
import script from "./HubDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./HubDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports